export function toggleActiveButton() {
	const button = document.querySelector('input[name="privacy"]');
	const togglePrivacy = document.querySelectorAll(".privacy-toggle");
	const popup = document.querySelector(".privacy-popup");

	togglePrivacy.forEach((element) => {
		element.addEventListener("click", () => {
			popup.classList.toggle("privacy-popup--active");
		});
	});
	button.addEventListener("change", (e) => {
		if (e.target.checked) {
			document.querySelector(".form__agree-button").classList.add("form__agree-button--active");
			return false;
		}
		document.querySelector(".form__agree-button").classList.remove("form__agree-button--active");
	});
}
